export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";

export const setActiveTab = (tabIndex) => ({
  type: SET_ACTIVE_TAB,
  payload: tabIndex,
});

const initialState = {
  activeTab: "General Information",
};

// Reducer
const tabReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    default:
      return state;
  }
};

export default tabReducer;
